import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import MusicPlayer from './../player/MusicPlayer';
import BottomBar from '../navigation/BottomBar';
import MobileContainer from '../views/MobileContainer';
import navigationStore from '../../stores/navigation';
import BackgroundMusicPlayer from '../player/BackgroundMusicPlayer';
import { ReactComponent as MuvikaLogo } from './../../assets/logo-horiz.svg';
import { ReactComponent as MuvikaLogoPro } from './../../assets/logo-horiz-pro.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import Stack from '@mui/material/Stack';
import playerStore from '../../stores/player';
import performanceStore from '../../stores/performance';
import NavBar from '../navigation/NavBar';
import { Views } from './../../enums/enums';
import MobilePlayer from '../player/MobilePlayer';
import sessionStore from './../../stores/session';
import { idText } from 'typescript';
import accountStore from '../../stores/account';

function Portrait() {
  const sessionToken = sessionStore((state) => state.sessionToken);
  const isWaiting = performanceStore((state) => state.isWaiting);
  const currentPerformance = performanceStore((state) => state.currentPerformance);
  const getStreamUrl = playerStore((state) => state.getStreamUrl);
  const isSideBarOn = navigationStore((state) => state.isSideBarOn);
  const currentView = navigationStore((state) => state.currentView);
  const goToView = navigationStore((state) => state.goToView);
  const isPlaying = playerStore((state) => state.isPlaying);
  const streamUrl = playerStore((state) => state.streamUrl);
  const account = accountStore((state) => state.account);
  const getAccount = accountStore((state) => state.getAccount);
  const playQueue = performanceStore((state) => state.playQueue);
  const setCurrentPosition = performanceStore((state) => state.setCurrentPosition);
  const drawerWidth = isSideBarOn ? 250 : 0;

  const videoJsOptions = {
    autoplay: false,
    controls: false,
    responsive: false,
    poster:null,
    fluid: false,
    width: "100%",
    height: "100%",
    sources: [{
      type: 'application/x-mpegURL'
    }]
  };

  return (
    <Box className="muvika-portrait">
      <MobilePlayer />
      <NavBar></NavBar>
      <BottomBar />
      <Box
        component="main"
      >
        <MobileContainer />
        <BackgroundMusicPlayer
          options={videoJsOptions}
        />
        {/* <MusicPlayer
          options={videoJsOptions}
        /> */}
      </Box>
    </Box>
  );
}

export default Portrait;
